import user from '@/store/modules/user';
import { bus } from './bus';
import { RegistrationRequest } from '@/store/models';
import { redirectToLocation } from '@/commons/redirectManager';

export const event = 'user.registrationsuccess';

bus.$on(event, (payload: {result: boolean, request: RegistrationRequest, userToken: string}) => {
    if (payload.result) {
        redirectToLocation('checkout/shipping', true);
    }
});
